import { createApiService } from "@/core/api/apiService";
import type { SearchResponseDto } from "../types/searchTypes";

export function createSearchApiClient() {
  const api = createApiService("search");

  return {
    getList: async (
      businessId: string,
      query: string,
      signal?: AbortSignal
    ): Promise<SearchResponseDto> => {
      const params = new URLSearchParams({ businessId, q: query });
      return api.get<SearchResponseDto>(`/?${params}`, { signal });
    },
  };
}

const searchApiService = createSearchApiClient();
export { searchApiService };
